const l10n = {
  de: {
    appName: "Altersrechner",
    nextMoment: "Nächster runder Geburtsmoment",
    remove: "Entfernen",
    doYouWant: "Willst du",
    really: "wirklich aus der Liste entfernen?",
    name: "Name",
    birthday: "Geburtstag",
    add: "Hinzufügen",
    reset: "Zurücksetzen",
    unit: "Einheit",
    dateOfBirth: "Geburtsdatum",
    isNow: "ist jetzt",
    old: "alt",
    milliseconds: "Millisekunden",
    seconds: "Sekunden",
    minutes: "Minuten",
    hours: "Stunden",
    days: "Tage",
    weeks: "Wochen",
    months: "Monate",
    years: "Jahre",
    marsyears: "Marsjahre",
    fromTheList: "wirklich von der Liste entfernen?",
  },
  en: {
    appName: "Age Calculator",
    nextMoment: "Next round birth moment",
    remove: "Remove",
    doYouWant: "Do you really want to remove",
    fromTheList: "from the list?",
    name: "Name",
    birthday: "Birthday",
    add: "Add",
    reset: "Reset",
    unit: "Unit",
    dateOfBirth: "Date of birth",
    isNow: "is now",
    old: "old",
    milliseconds: "milliseconds",
    seconds: "seconds",
    minutes: "minutes",
    hours: "hours",
    days: "days",
    weeks: "weeks",
    months: "months",
    years: "years",
    marsyears: "mars years",
  },
};
export { l10n };
